import { useRecurly } from "@recurly/react-recurly"
import React, { useState } from "react"
import CustomLoader from "../CustomLoader";
import AppleIcon from "@mui/icons-material/Apple";
import toast from "react-hot-toast";
import "./style.css";
import CustomButton from "../CustomButton";

const CustomApplePayButton = ({ type = "purchase", plan, applePayCallButtonback }) => {

    const recurly = useRecurly()
    const [loading, setLoading] = useState(false);

    const checkoutPricing = recurly.Pricing.Checkout()
    const subscription = recurly.Pricing.Subscription()

    checkoutPricing
        .currency(plan?.currency)
        .subscription(
            subscription
                .plan(plan?.code, { quantity: 1 })
                .currency(plan?.currency)
                .done()
        )
        .catch(err => {
        })
        .done()


    const applePay = recurly.ApplePay({
        country: "US",
        currency: type == "purchase" ? plan?.currency : "USD",
        label: type == "purchase" ? plan?.name : "Indi Update Billing Details",
        total: type == "purchase" ? (plan?.amount + ".00") : "0.00",
        pricing: type == "purchase" ? checkoutPricing : undefined
    })

    // applePay.on("error", function (err) {
    //     toast.error("Unable to setup Apple Pay");
    // })

    applePay.on("token", async function (token) {
        try {
            if (!token) {
                toast.error("Unable to setup Apple Pay");
            } else {
                applePayCallButtonback(token);
            }
        } catch (err) {
            toast.error("Unable to setup Apple Pay");
        }
    })

    const handleApplePayClick = () => {


        applePay?.ready(function () {
            applePay.begin()
        })

    }

    return (
        true && <>
            <CustomButton id="custom-apple-pay-button" style={{ paddingLeft: "40px" }} onClick={handleApplePayClick}>
                {
                    type == "update"
                        ? "Update with"
                        : `${type == "purchase" ? "Subscribe" : "Renew"} with`
                }
                <AppleIcon sx={{ color: '#fff' }} /> Pay
            </CustomButton>

            {loading && <CustomLoader loading={loading} />}
        </>
    )
}

export default CustomApplePayButton
